import type { FilterKeys } from '@dresscode-frontend/utility-types';
import type { ColumnDef } from '@tanstack/table-core';
import { DataTableColumnHeader } from '@/components/DataTable/Columns/DataTableColumnHeader';
import type { HelperOptions } from '@/components/DataTable/types';
import MultiValueCell, { MultiValueCellRow } from '../Cells/MultiValueCell';
type MultiValueAttrItem = {
  id: string;
  name: string;
  isPrimary?: boolean;
};
export function multiValueAttrColumn<TData>(id: FilterKeys<TData, MultiValueAttrItem[]> & string, helperOptions: HelperOptions & {
  /** 複数項目のうちメインであることを示すラベル。未指定の場合は「メイン」と表示される */
  primaryLabelKey: 'primary' | 'hrPrimary';
}): ColumnDef<TData> {
  const {
    i18nKey,
    minWidth,
    sortable = false,
    primaryLabelKey
  } = helperOptions;
  return {
    accessorKey: id,
    meta: {
      i18nKey: i18nKey,
      thStyle: {
        minWidth
      }
    },
    enableSorting: sortable,
    header: DataTableColumnHeader,
    cell({
      getValue
    }) {
      const items = getValue();
      return <MultiValueCell>
          {items.map(item => <MultiValueCellRow key={item.id} isPrimary={item.isPrimary && items.length > 1} primaryLabelKey={primaryLabelKey}>
              {item.name}
            </MultiValueCellRow>)}
        </MultiValueCell>;
    }
  } satisfies ColumnDef<TData, MultiValueAttrItem[]> as ColumnDef<TData>;
}